import { render, staticRenderFns } from "./ButtonPreview.vue?vue&type=template&id=5dff80fc&scoped=true&"
import script from "./ButtonPreview.vue?vue&type=script&lang=js&"
export * from "./ButtonPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dff80fc",
  null
  
)

export default component.exports